// @ts-check

/** Canonical Indian GST state/UT names - mirrors backend/utils/gst_states.py's GST_STATE_NAMES
 * (CBIC's official state-code list). Kept as a plain list here since it's static reference data a
 * dropdown needs at render time; the backend independently validates against its own copy before
 * ever trusting a state for the CGST/SGST vs IGST split, so this list only needs to stay roughly
 * in sync, not be the security boundary. */
export const GST_STATE_NAMES = [
  'Andaman And Nicobar', 'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chandigarh',
  'Chhattisgarh', 'Dadra And Nagar Haveli And Daman And Diu', 'Delhi', 'Goa', 'Gujarat', 'Haryana',
  'Himachal Pradesh', 'Jammu And Kashmir', 'Jharkhand', 'Karnataka', 'Kerala', 'Ladakh',
  'Lakshadweep', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland',
  'Orissa', 'Other Country', 'Other Territory', 'Puducherry', 'Punjab', 'Rajasthan', 'Sikkim',
  'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
];
